import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent() {
  return (
    <Svg
      width={60}
      height={60}
      viewBox="0 0 512 512"
    >
      <Path
        d="M372.718 190.761L256.002 503.904 36.688 380.246 36.688 132.907z"
        fill="#e0b76e"
      />
      <Path
        d="M256.002 9.249L36.688 132.907 256.002 256.576 256.002 503.904 475.316 380.246 475.316 132.907z"
        fill="#f4ce8f"
      />
      <Path
        d="M256.987 255.421L256.987 502.748 476.301 379.09 476.301 131.751z"
        fill="#f2ca7f"
      />
      <Path
        d="M177.196 459.48L177.196 212.14 267.779 161.059 267.79 161.059 267.788 161.059 193.595 161.059 193.971 126.161 193.977 126.158 109.346 173.876 109.346 420.36"
        fill="#8cc1ea"
      />
      <Path
        d="M177.196 459.48L177.196 212.14 109.346 173.876 109.346 420.36"
        fill="#79b1d6"
      />
      <Path
        d="M329.145 49.986L238.563 101.068 238.551 101.068 238.554 101.068 312.746 101.068 312.371 135.966 312.365 135.969 396.995 88.251"
        fill="#8cc1ea"
      />
      <Path d="M368.8 289.539a8.669 8.669 0 00-2.172-12.064l-23.626-16.418a8.664 8.664 0 00-12.503 2.874l-24.38 43.411a8.669 8.669 0 0015.114 8.489l8.156-14.521v108.017a8.668 8.668 0 008.668 8.668 8.668 8.668 0 008.668-8.668V284.753l10.012 6.958a8.666 8.666 0 0012.063-2.172zM426.408 325.227a8.667 8.667 0 00-11.802 3.312l-8.157 14.522V235.045a8.668 8.668 0 00-8.668-8.668 8.668 8.668 0 00-8.668 8.668v124.573l-10.012-6.958a8.669 8.669 0 00-9.892 14.236l23.626 16.418a8.676 8.676 0 006.888 1.33 8.667 8.667 0 005.615-4.203l24.381-43.411a8.666 8.666 0 00-3.311-11.803z" />
      <Path d="M479.57 124.783L260.256 1.117a8.667 8.667 0 00-8.514 0L32.427 124.783a8.669 8.669 0 00-4.41 7.55v247.332a8.666 8.666 0 004.41 7.55l140.518 79.235c.061.035.121.071.184.103l78.613 44.329a8.665 8.665 0 008.516 0l219.315-123.666a8.669 8.669 0 004.41-7.55V132.334a8.674 8.674 0 00-4.413-7.551zM318.909 94.395a8.668 8.668 0 00-6.162-2.573H271.58l57.118-32.211 50.207 28.311-57.707 32.538.216-19.877a8.665 8.665 0 00-2.505-6.188zM45.351 147.171l55.327 31.198v187.453a8.668 8.668 0 0017.336 0V188.144l50.515 28.484v227.431l-50.515-28.484v-20.861a8.668 8.668 0 00-17.336 0V405.8l-55.327-31.198V147.171zm142.083 19.405a8.668 8.668 0 006.162 2.573h41.168l-57.569 32.464-50.207-28.311 58.155-32.79-.214 19.877a8.654 8.654 0 002.505 6.187zm59.897 321.917l-61.467-34.66v-227.43l61.467 34.66v227.43zm17.335 0v-227.43l112.308-63.328a8.67 8.67 0 00-8.514-15.102l-112.462 63.415-61.158-34.486 76.906-43.368a8.699 8.699 0 001.523-1 8.651 8.651 0 003.185-6.715 8.668 8.668 0 00-8.668-8.668h-65.431l.279-25.816a8.67 8.67 0 00-12.916-7.967l-80.38 45.321-55.008-31.015L255.999 18.618l55.053 31.043-76.442 43.107a8.67 8.67 0 003.943 16.39h65.431l-.28 25.85a8.667 8.667 0 0012.918 7.932l79.931-45.068 61.114 34.46-54.159 30.539c-4.17 2.352-5.644 7.638-3.294 11.808s7.639 5.643 11.808 3.294l54.625-30.802v227.433L264.666 488.493z" />
    </Svg>
  )
}

export default SvgComponent;